var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 449.4 111.4",
    style: {
      enableBackground: "new 0 0 449.4 111.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.7,108.7L193,9.2l1.8-2.5c0.4-0.4,0.9-0.9,1.5-1.3c0.5-0.4,1-0.7,1.5-0.9c0.5-0.2,1.1-0.4,1.8-0.6 c0.7-0.2,1.4-0.3,2-0.3c1.2,0,2.3,0,3.5,0l25.2,0c0.6,0,1.1,0,1.7,0c0.1,0,1,0,1.6,0.7c0.5,0.6,0.7,1.5,0.3,2.2 c-0.4,0.5-0.8,1.1-1.1,1.6l-70.7,101.9c-0.1,0.1-0.2,0.3-0.4,0.4c-0.2,0.1-0.3,0.3-0.5,0.3c-0.3,0.1-0.6,0.3-1.1,0.4 c-0.3,0.1-0.6,0.1-0.6,0.1c-1-0.1-31-0.2-34.1,0c-0.3,0-0.8,0-1.2-0.2c-0.2-0.1-0.5-0.2-0.7-0.6c-0.2-0.3-0.2-0.6-0.2-0.7 c0-0.1,0-0.3,0.1-0.5C123.4,108.9,123.6,108.8,123.7,108.7L123.7,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.2,5.2c-1-1.8-0.7-3.8,0.3-4.7c1.3-1.1,4.2-0.7,5.7,1.9c4.2,5.9,7,10.4,11.2,16.3l1.4,1.5 c0.5,0.4,1.3,0.6,1.5,0.6c1.2,0,2.1-0.3,2.9-1.6c0.1-0.2,0.3-0.9,0.3-1.3c-0.1-2,0.2-1.9-2.9-6c-1.9-2.5-2.2-3.1-2.4-3.9 c-0.1-0.5-0.2-2.2,0.9-3.1c0.9-0.7,2.1-0.6,2.9-0.3c1.1,0.4,1.6,1.1,1.6,1.1l0.4,0.5c0.9,1.4,7.2,11.7,9.4,12c0.3,0,0.7,0,0.7,0 c1.1-0.1,2.6-0.9,3-2.4c0.4-1.3-0.3-2.5-0.5-2.7c-0.6-1.4-1.1-1.7-2-3.1c-0.7-1.1-1-2-0.8-3.1c0.2-1.1,1.3-1.6,1.3-1.6 c0.7-0.4,1.3-0.5,2.3-0.4c1.2,0.1,2.1,1.2,2.4,1.6c1.9,2.7,54.1,78.2,68.6,99.1c0.4,0.7,0.9,1.2,1.2,1.8c0.4,0.6,1,1.1,1.1,1.7 c0.4,1.1-0.9,1.9-1.9,1.9c-1.3,0-2.6,0-3.9,0c-0.3,0-8.6-0.2-25.1-0.2c-2.8,0-5.8,0-8.1-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "161.4,54.5 181.1,82.5 179.2,85.3 159.5,57.3  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "katman_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,111.4H3.1c-2.1,0-3.1-1-3.1-3.1V6.2c0-2.1,1-3.1,3.1-3.1h40.5c7.7,0,14.5,1.5,20.3,4.6 s10.3,7.4,13.5,12.8c3.2,5.5,4.7,11.7,4.7,18.6c0,7.4-1.5,13.9-4.6,19.6s-7.4,10-13.2,13.1s-12.5,4.7-20.5,4.7H25v31.8 C25,110.3,23.9,111.4,21.9,111.4L21.9,111.4z M49.8,52c2.3-1.2,4.2-3,5.5-5.2s2-4.7,2-7.5s-0.7-5-2-7.1s-3.1-3.7-5.4-4.9 s-4.9-1.7-7.8-1.7H25v28.2h17C44.8,53.9,47.4,53.3,49.8,52L49.8,52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.4,111.4H93.6c-2.1,0-3.1-1-3.1-3.1V6.2c0-2.1,1-3.1,3.1-3.1h18.8c2.1,0,3.1,1,3.1,3.1v102.1 C115.5,110.4,114.4,111.4,112.4,111.4L112.4,111.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.9,109.2c0,0.7-0.2,1.3-0.7,1.7s-1.1,0.6-1.9,0.6h-19.4c-1.8,0-2.9-0.8-3.5-2.5L314.7,93h-41.4l-5.6,15.9 c-0.5,1.7-1.7,2.5-3.5,2.5h-19.4c-0.8,0-1.5-0.2-2-0.6s-0.7-0.9-0.7-1.7c0-0.4,0.1-0.8,0.2-1.3L282.2,5.4c0.6-1.6,1.8-2.5,3.5-2.5 h16.7c1.8,0,3,0.8,3.6,2.5l39.5,102.4C345.8,108.3,345.9,108.7,345.9,109.2L345.9,109.2z M307.5,71.9l-12.3-34.8l-1.2-4.4l-1.1,4.4 l-12.3,34.8H307.5L307.5,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.4,108.3V6.2c0-2.1,1-3.1,3.1-3.1h37c10.4,0,20,2.4,28.7,7.1c8.7,4.7,15.6,11.2,20.6,19.5 s7.6,17.5,7.6,27.5s-2.5,19.2-7.5,27.5c-5,8.3-11.9,14.8-20.5,19.5s-18.2,7.1-28.6,7.1h-37.2C353.4,111.4,352.4,110.4,352.4,108.3 L352.4,108.3z M409.1,83.6c4.6-2.6,8.3-6.1,10.9-10.7s4-9.8,4-15.7s-1.3-10.9-4-15.5s-6.3-8.2-11-10.8c-4.6-2.6-9.9-3.9-15.7-3.9 h-16v60.4h16.2C399.3,87.4,404.5,86.2,409.1,83.6L409.1,83.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.02de9b50d79874f6bd2f33f557523693.svg";
export { ForwardRef as ReactComponent };